module.exports = __webpack_public_path__ + "img/despread.9b9953a3.svg";